<div class="container mt-4">
    <h2 class="text-center">Register a New Project</h2>
    <form [formGroup]="projectForm" (ngSubmit)="submitForm()" class="card p-4 shadow-sm">
  
      <div class="mb-3">
        <label for="name" class="form-label">Project Name</label>
        <input type="text" id="name" formControlName="name" class="form-control" [class.is-invalid]="isSubmitted && projectForm.controls['name'].invalid">
        <div *ngIf="isSubmitted && projectForm.controls['name'].invalid" class="invalid-feedback">
          Project Name is required (min 3 characters).
        </div>
      </div>
  
      <div class="mb-3">
        <label for="description" class="form-label">Description</label>
        <textarea id="description" formControlName="description" class="form-control" [class.is-invalid]="isSubmitted && projectForm.controls['description'].invalid"></textarea>
        <div *ngIf="isSubmitted && projectForm.controls['description'].invalid" class="invalid-feedback">
          Description is required.
        </div>
      </div>
  
      <div class="row">
        <div class="col-md-6 mb-3">
          <label for="startDate" class="form-label">Start Date</label>
          <input type="date" id="startDate" formControlName="startDate" class="form-control" [class.is-invalid]="isSubmitted && projectForm.controls['startDate'].invalid">
          <div *ngIf="isSubmitted && projectForm.controls['startDate'].invalid" class="invalid-feedback">
            Start Date is required.
          </div>
        </div>
  
        <div class="col-md-6 mb-3">
          <label for="endDate" class="form-label">End Date</label>
          <input type="date" id="endDate" formControlName="endDate" class="form-control" [class.is-invalid]="isSubmitted && projectForm.controls['endDate'].invalid">
          <div *ngIf="isSubmitted && projectForm.controls['endDate'].invalid" class="invalid-feedback">
            End Date is required.
          </div>
        </div>
      </div>
  
      <div class="mb-3">
        <label for="budget" class="form-label">Budget (₹)</label>
        <input type="text" id="budget" formControlName="budget" class="form-control" [class.is-invalid]="isSubmitted && projectForm.controls['budget'].invalid">
        <div *ngIf="isSubmitted && projectForm.controls['budget'].invalid" class="invalid-feedback">
          Budget must be a valid number.
        </div>
      </div>
  
      <button type="submit" class="btn btn-primary w-100">Register Project</button>
    </form>
  </div>
  